import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_all, fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';

import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';

import {
  AppBar,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  MenuItem,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';

import {
  Button,
  DatePicker,
  MultiSelect,
  Page,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { SnackSaved } from '../../../components/v2/snacks/Saved';

import { Foodstuff } from '../../../models/Foodstuff';
import { NutritionalValue } from '../../../models/NutritionalValue';

const { DateTime } = require("luxon");

import HelpersLanguage from '../../../actions/helpers/language';
import { FoodstuffMeasure } from '../../../models/FoodstuffMeasure';
import { FoodstuffValue } from '../../../models/FoodstuffValue';

type Props = {}

export const AdminFoodCalculationFoodstuffEdit: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  const params = useParams();
  const queryClient = useQueryClient();
  
  const [currentLanguageId, setCurrentLanguageId] = useState<number>(1);
  const [objectId, setObjectId] = useState<string | undefined>(params.id);
  const [mainObject, setMainObject] = useState<Foodstuff>({
    name: ''
  });
  const [savedOpen, setSavedOpen] = useState<boolean>(false);
  const [errors, setErrors] = useState<{[z:string]: boolean}>({});

  const {
    data: object,
    isLoading: objectLoading,
    isError: objectError,
    isSuccess: objectSuccess,
    refetch: objectRefetch,
  } = useQuery({
    queryKey: ["foodstuff", login?.id, objectId],
    queryFn: () =>
      fetch_one<Foodstuff>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'foodstuff',
          id: objectId,
          fields: ['id', 'name', 'full_name', 'foodstuff_measure', 'foodstuff_measure_id', 'foodstuff_values', 'foodstuff_measure_link_ids'],
          sub_fields: {
            foodstuff_measure: ['id', 'name'],
            foodstuff_values: ['id', 'nutritional_value', 'nutritional_value_id', 'grams100_value'],
            nutritional_value: ['id', 'name'],
          },
        },
        login
      ),
    enabled: !!login?.id && parseInt(objectId || '', 10) > 0,
  });
  const {
    data: foodstuffMeasures,
    // isLoading: tagsLoading,
    // isError: tagsError,
    // isSuccess: tagsSuccess,
    // refetch: tagsRefetch,
  } = useQuery({
    queryKey: ["admin", "all_foodstuff_measures"],
    queryFn: () =>
      fetch_all<FoodstuffMeasure>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'foodstuff_measure',
          fields: ['id', 'name', 'internal_name'],
          order: "internal_name ASC",
          per_page: 1000,
          page: 0,
          filter: {
            search: '',
            advanced: {
              is_admin: 1
            }
          }
        },
        login
      ),
    enabled: !!login?.id
  });
  const {
    data: nutritionalValues,
    // isLoading: objectsLoading,
    // isError: objectsError,
    // isSuccess: objectsSuccess,
    refetch: nutritionalValuesRefetch,
  } = useQuery({
    queryKey: ["admin", "all_nutritional_values"],
    queryFn: () =>
      fetch_all<NutritionalValue>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/fetch_all`,
        {
          object: 'nutritional_value',
          fields: ['id', 'name', 'has_maximum', 'measure', 'is_percentage_energy', 'is_grams_per_kilogram', 'is_calculated'],
          order: "name ASC",
          per_page: 1000,
          page: 0,
          filter: {
            search: '',
            advanced: {
              is_admin: 1
            }
          }
        },
        login
      ),
    enabled: !!login?.id
  });







  const mutationSave = useMutation({
    mutationFn: (pars: {
      formData: any;
      keepOpen?: boolean
    }) => {
      return fetch_one<Foodstuff>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/save`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSavedOpen(true);
      queryClient.invalidateQueries({ queryKey: ["admin", "foodstuffs"] });
      // if (!!isReturn) {
        navigate(`/foodstuffs`);
      // } else {
      //   if (!variables.keepOpen) navigate("/knowledge_courses");
      //   if (!!variables.keepOpen && objectId === 'new') navigate(`/knowledge_course/${data.id}`);
      //   if (!!variables.keepOpen && objectId !== 'new') objectRefetch();
      // }
    },
  });









  useEffect(() => {
    if (objectId !== 'new') objectRefetch();
  }, [objectId]);
  useEffect(() => {
    setObjectId(params.id);
  }, [params.id]);
  useEffect(() => {
    if (!!objectSuccess) setMainObject(object);
  }, [object]);
  useEffect(() => {
    let err:any = {};
    if (Object.values(mainObject.full_name || []).filter(fff => !!fff).length < 1) err.name = true;
    // if (!mainObject.content_layout_key) err.content_layout_key = true;
    // if (!mainObject.author) err.author = true;
    // if (!mainObject.teaser) err.teaser = true;
    // if (!!mainObject.enabled && !mainObject.published_at) err.published_at = true;
    // if (!mainObject.coach_id) err.coach_id = true;
    // if (!mainObject.start_time) err.start_time = true;
    // if (!mainObject.end_time) err.end_time = true;
    // if (!!mainObject.start_time && !!mainObject.end_time && DateTime.fromFormat(mainObject.start_time, "dd/LL/y t") > DateTime.fromFormat(mainObject.end_time, "dd/LL/y t")) err.start_time = true;
    // if ((mainObject.max_subscribers || 0) < 1) err.max_subscribers = true;
    
    setErrors(err);
  }, [mainObject]);

  return <Page
    title={t("admin.menu.foodstuff")}
    titleCrumbs={[
      {
        title: t("admin.menu.foodstuffs"),
        path: "/foodstuffs"
      }
    ]}
  >
   <Paper sx={{padding: 2}}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">{t("foodstuffs.headings.general")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)"}}>
          <AppBar position="static" sx={{backgroundColor: theme.palette.primary.contrastText}}>
            <Tabs value={currentLanguageId} onChange={(ev, i) => {
              setCurrentLanguageId(i);
              // setFlickerEditor(true);
              // setTimeout(() => {setFlickerEditor(false);}, 200);
            }}>
              {HelpersLanguage.available_locales().map((locale, i) => {
                return (<Tab value={HelpersLanguage.mapping_to_id(locale)} label={locale.toUpperCase()} id={`locale_tab_${locale}`} />)
              })}
            </Tabs>
          </AppBar>
        </Grid>
        <Grid item xs={12} sx={{borderLeft: "4px solid rgba(0, 0, 0, 0.54)", marginTop: 1}}>
          <TextInput
            id="name"
            caption={t("admin.models.foodstuffs.name")}
            starred
            value={(mainObject?.full_name || {})[currentLanguageId] || ""}
            onChange={(e) => {
              setMainObject({
                ...mainObject,
                full_name: {
                  ...(mainObject.full_name || {}),
                  [currentLanguageId]: e
                }
              });
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MultiSelect
            id="foodstuff_measure_link_ids"
            caption={t("admin.models.foodstuffs.foodstuff_measure_link_ids")}
            backend
            value={(mainObject.foodstuff_measure_link_ids || [])}
            chips
            options={(foodstuffMeasures || []).map(skill => {return {id: skill.id || 0, name: skill.internal_name || ''};})}
            setValue={(e) => {
              setMainObject({
                ...mainObject,
                foodstuff_measure_link_ids: e.map(mm => parseInt(mm.toString(), 10))
              });
            }}
          >
            <MenuItem value=""></MenuItem>
            {(foodstuffMeasures || []).map(pt => <MenuItem value={pt.id}>{pt.internal_name}</MenuItem>)}
          </MultiSelect>
        </Grid>
        {/* <Grid item xs={12}>
          {(foodstuffMeasures || []).sort((a, b) => ((mainObject.foodstuff_measure_link_ids || []).filter(fff => fff === b.id).length - (mainObject.foodstuff_measure_link_ids || []).filter(fff => fff === a.id).length)).map(skill => <Chip
            sx={{marginRight: 1, marginBottom: 1, cursor: 'pointer'}}
            label={skill.name}
            onClick={(e) => {
              if ((mainObject.foodstuff_measure_link_ids || []).filter(fff => fff === skill.id).length > 0) {
                setMainObject({
                  ...mainObject,
                  foodstuff_measure_link_ids: (mainObject.foodstuff_measure_link_ids || []).filter(fff => fff !== skill.id)
                });
              } else {
                setMainObject({
                  ...mainObject,
                  foodstuff_measure_link_ids: [...(mainObject.foodstuff_measure_link_ids || []), (skill.id || 0)]
                });
              }
            }}
            variant="outlined"
            icon={(mainObject.foodstuff_measure_link_ids || []).filter(fff => fff === skill.id).length > 0 ? <DoneIcon /> : <AddIcon />}
            color={(mainObject.foodstuff_measure_link_ids || []).filter(fff => fff === skill.id).length > 0 ? "primary" : 'default'}
          />)}
        </Grid> */}
        <Grid item xs={12} sx={{marginTop: 5}}>
          <Typography variant="h5">{t("foodstuffs.headings.tracked_values")}</Typography>
          <Divider />
        </Grid>
        <Grid item xs={1}>
          <Typography sx={{textDecoration: 'underline'}}>{t("foodstuffs.values.enabled")}</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography sx={{textDecoration: 'underline'}}>{t("foodstuffs.values.name")}</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography sx={{textDecoration: 'underline'}}>{t("foodstuffs.values.grams100_value")}</Typography>
        </Grid>
        <Grid item xs={4}>
        </Grid>
        {(nutritionalValues || []).filter(nutritionalValue => !nutritionalValue?.is_calculated).map(nutritionalValue => <>
          <Grid item xs={1}>
            <Checkbox checked={((mainObject.foodstuff_values || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0} onChange={(e) => {
              if (!e.target.checked) {
                let newValues:FoodstuffValue[] = [...(mainObject.foodstuff_values || []).filter(fff => fff.nutritional_value_id !== nutritionalValue?.id)];

                setMainObject({
                  ...mainObject,
                  foodstuff_values: newValues
                });
              }
              if (!!e.target.checked) {
                let newValues:FoodstuffValue[] = [...(mainObject.foodstuff_values || []).filter(fff => fff.nutritional_value_id !== nutritionalValue?.id)];

                newValues.push({
                  nutritional_value_id: nutritionalValue?.id,
                  grams100_value: undefined
                });

                setMainObject({
                  ...mainObject,
                  foodstuff_values: newValues
                });
              }
            }} />
          </Grid>
          <Grid item xs={5}>
            <Typography sx={{lineHeight: '42px'}}>{nutritionalValue.name}</Typography>
          </Grid>
          <Grid item xs={2}>
            {((mainObject.foodstuff_values || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || []).length > 0 && <TextInput
              id={["nutri_val_low", nutritionalValue.id].join("_")}
              value={(((mainObject.foodstuff_values || []).filter(fff => fff.nutritional_value_id === nutritionalValue?.id) || [])[0] || {})?.grams100_value?.toString() || ''}
              onChange={(e) => {
                let newValues:FoodstuffValue[] = [...(mainObject.foodstuff_values || [])];
                let passed = false;

                newValues.forEach(newAdhLink => {
                  if (newAdhLink.nutritional_value_id === nutritionalValue?.id) {
                    passed = true;
                    newAdhLink.grams100_value = !!e ? (isNaN(parseInt(e, 10)) ? undefined : parseInt(e, 10)) : undefined;
                  }
                });
                if (!passed) {
                  newValues.push({
                    nutritional_value_id: nutritionalValue?.id,
                    foodstuff_id: mainObject?.id,
                    grams100_value: (!!e ? (isNaN(parseInt(e, 10)) ? undefined : parseInt(e, 10)) : undefined)
                  });
                }

                setMainObject({
                  ...mainObject,
                  foodstuff_values: newValues
                });
              }}
              sx={{marginTop: 0, height: '30px'}}
            />}
          </Grid>
          <Grid item xs={4}>
          </Grid>
        </>)}












        <Grid item xs={12} sx={{
          alignContent: 'baseline',
          textAlign: 'center',
          position: {
              xs: 'relative',
              md: 'sticky'
            },
          bottom: '-24px',
          backgroundColor: 'white',
          zIndex: 1201
        }}>
          <Divider sx={{marginTop: 1, marginBottom: 0}} />

          {!!mutationSave.isPending && <CircularProgress />}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.save")}
            id='save'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              let trans:{[s:string]: {[n:number]: string}} = {};
              // @ts-ignore
              mainObject.name = ((mainObject.full_name || {})[1] || '')
              trans['name'] = {};
              // @ts-ignore
              Object.keys(mainObject.full_name || {}).filter(fff => fff.toString() !== '1').forEach(mm => {
              // @ts-ignore
                trans['name'][parseInt(mm, 10)] = (mainObject.full_name || {})[parseInt(mm, 10)];
              });

              mutationSave.mutate({
                formData: {
                  object: 'foodstuff',
                  handler_id: login?.id,
                  fields: ['id'],
                  ob: {
                    ...mainObject,
                    id: parseInt(objectId || '', 10) > 0 ? objectId : undefined,
                  },
                  translations: trans
                },
              });
            }}
            sx={{marginBottom: 1, marginTop: 1}}
          />}
          {/* {!mutationSave.isPending && <Button
            label={t("shared.buttons.save_keep_open")}
            id='save_opened'
            disabled={Object.keys(errors).length > 0}
            contained
            onClick={(v) => {
              saveObject(true);
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />} */}
          {!mutationSave.isPending && <Button
            label={t("shared.buttons.cancel")}
            id='cancel'
            text
            // contained
            onClick={(v) => {
              navigate("/foodstuffs");
            }}
            sx={{marginLeft: 1, marginBottom: 1, marginTop: 1}}
          />}
        </Grid>
      </Grid>
    </Paper>
    
    <SnackSaved open={savedOpen} setOpen={setSavedOpen} />
  </Page>;
}
